import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Code } from 'src/app/core/model/dictionary';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';

@Component({
  selector: 'app-household-add',
  templateUrl: './household-add.component.html',
  styleUrls: ['./household-add.component.scss']
})
export class HouseholdAddComponent
{
  @Input() public member: any;
  @Input() public open: boolean;

  @Output() public closing: EventEmitter<boolean> = new EventEmitter();

  public householdForm: any;
  public relationships: Code[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private dictionaryService: DictionaryService,
    private messengerService: MessengerService)
  { 
    
    this.dictionaryService.getCachedFamilyMembers().subscribe({
      next: (data) =>
      {
        this.relationships = data;
      }
    });

    // Set form
    this.householdForm = this.fb.group({
      relationship: [null, Validators.required]      
    }); 
  }

  public get relationship(): UntypedFormControl
  {
    return this.householdForm.get('relationship');
  }  
  
  public close(): void
  {    
    this.closing.emit();
  }

  public changeRelationship(relationshipId: any): void
  {
    this.messengerService.sendMessage(new MessageSubject('addHouseholdMemberRelationship', relationshipId));
  }  
}
